// extracted by mini-css-extract-plugin
module.exports = {"container":"ActionsPanel_container__OIqat","action":"ActionsPanel_action__3j0_x","last_item":"ActionsPanel_last_item__2TvYk"};